import React from 'react';
import AuditLogsPage from '../../features/audit-logs/pages/AuditLogsPage';

export const superadminRoutes = [
  { path: '/audit-logs', element: <AuditLogsPage /> },
];
